export default __webpack_public_path__ + "static/media/cat1.f86b2376.jpg";